import React from 'react';
import styled from '@emotion/styled';
import { Link as L } from 'react-router-dom';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

const Content = styled.div`
  display: flex;
  margin-top: 30vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h3`
  font-size: 32px;
  color: #000;
  margin-bottom: 16px;
`;

const Subtitle = styled.p`
  font-size: 24px;
  color: #000;
  margin: 0;
`;

const Link = styled(L)`
  color: #2e3b55;
`;

const NotFound = () => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <Content>
        <Title>{i18n('NF.Title')}</Title>
        <Subtitle>
          {i18n('NF.Subtitle')} <Link to="/venues">venues</Link>
        </Subtitle>
      </Content>
    </Wrapper>
  );
};

export default NotFound;
